export default __webpack_public_path__ + "static/media/LABORe_Logo_branco.7de2605c.png";